module.exports = __webpack_public_path__ + "static/media/edit.ced554c2.svg";